import { createWebHashHistory, createRouter, type RouteRecordRaw } from 'vue-router'


import ListView from '@/views/ListView.vue'
import QuizesView from '@/views/QuizesView.vue'
import DetailsView from '@/views/DetailsView.vue'
import PresentationView from '@/views/PresentationView.vue'
import PlaylistMode from '@/views/PlaylistMode.vue'
import DetailsViewChild from '@/views/DetailsViewChild.vue'
import QuizesDetailsView from '@/views/QuizesDetailsView.vue'
import type {
	LanguageItem,
	MedicalSpecialties,
	studyTypes,
	outcomeType,
	TargetAudienceItem,
	PublishingStatusList,
	AplicationDomain
} from '@/types'

const routes: RouteRecordRaw[] = [
	{
		path: '/',
		name: 'list',
		component: ListView,
		props: (route: any) => ({
			selectedStatus: route.query.authoringStatus || 'New',
			selectedPublishingStatus: route.query.publishingStatus || 'Unpublished',
			selectedPackageType: route.query.packageType || ''
		}),
		children: [
			{
				path: 'presenation/:id',
				name: 'list-presenation',
				component: PresentationView,
				props: true
			}
		]
	},

	{
		path: '/print/:id/',
		name: 'prepare-print',
		component: DetailsViewChild,
		props: true
	},

	{
		path: '/details/:id/',
		name: 'details',
		component: DetailsView,
		props: false,
		children: [
			{
				path: 'presenation',
				name: 'details-presenation',
				component: PresentationView,
				props: true
			},
			{
				path: 'print',
				name: 'details-prepare-print',
				component: DetailsViewChild,
				props: true
			}
		]
	},

	{
		path: '/:id/edit-post',
		name: 'edit-post',
		component: ListView
	},
	{
		path: '/presenation/',
		name: 'presenation',
		component: PresentationView,
		props: (route: any) => ({
			id: route.params.id,
			targetSection: route.query.section,
			activeIndex: route.query.activeIndex || null,
			selectedLanguage: route.query.lng || 'de',
			selectedStatus: route.query.authoringStatus || 'New',
			selectedPublishingStatus: route.query.publishingStatus || 'Unpublished',
			selectedPackageType: route.query.packageType || 'Review Post'
		})
	},
	{
		path: '/playlist',
		name: 'playlist',
		component: PlaylistMode,
		props: true
	},
	{
		path: '/quizes',
		name: 'quizes',
		component: QuizesView,
		props: true
	},
	{
		path: '/quizes/:id',
		name: 'quizes-details',
		component: QuizesDetailsView,
		props: true
	}
]

export function createRouterInstance(forceDetailsId?: string) {
	//console.log('routes', routes[0]);
	if(forceDetailsId){
		routes[0].redirect = { name: 'details', params: { id: forceDetailsId } };
	}
  return createRouter({
    history: createWebHashHistory(),
    routes,
    // scrollBehavior(to, from, savedPosition) {
    //   if (savedPosition) return savedPosition
    //   return { top: 0 }
    // }
  })
}

// export default router
